$("#request-reset-password-link").on("click", function () {
  const email = { email: $("#portal-user-email").text().trim(), success: true };

  $.ajax({
    url: "/Account/ChangePassword",
    method: "POST",
    contentType: "application/json; charset=utf-8",
    dataType: "json",
    data: JSON.stringify(email),
  }).done(function (data) {
    if (data.succeed) {
      $.notificationSuccess(data.header, data.message);
    } else {
      showServerValidation(data.validationErrors);
    }
  });
});

$(".button-menu-mobile").on("click", function () {
  if ($(this).hasClass("open")) {
    localStorage.setItem("LeftMenu_open", true);
  } else {
    localStorage.setItem("LeftMenu_open", false);
  }
});
$(document).on("click", "body", function () {
  if ($(".left-side-menu").css("display") == "none") {
    localStorage.setItem("LeftMenu_open", false);
  }
});
loadLeftMenuState();
$(window).on("resize", function () {
  loadLeftMenuState();
});

function loadLeftMenuState() {
  if (localStorage.getItem("LeftMenu_open") === "false") {
    if ($(".button-menu-mobile").hasClass("open"))
      $(".button-menu-mobile").click();
  }
  if (
    localStorage.getItem("LeftMenu_open") === "true" &&
    $(".left-side-menu").css("display") != "none"
  ) {
    if (!$(".button-menu-mobile").hasClass("open"))
      $(".button-menu-mobile").click();
  }
}
